// generated by scripts/build_data.py
export const DATA_VERSION = "f6e62000bb";
export const DATA_COUNTRIES = ["us", "uk", "other"] as const;
/** names in each country's deck, for the welcome screen before the names have loaded */
export const DATA_COUNTS: Record<string, number> = {"us": 30889, "uk": 20382, "other": 31431};
